import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { RulesDocumentTeacherType } from "../../../types/Teacher";
import { get } from "../../../utils/axios-config";
import { RULES_DOCUMENT_TEACHER } from "../../../utils/constants";

export const getTeacherRequiredDocuments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100'
    });
    const url = `${RULES_DOCUMENT_TEACHER}?${queryParams.toString()}`;
    return await get<PagedResultsType<RulesDocumentTeacherType>>(url)
};